var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70019 4.12397C5.70019 4.69966 5.70019 5.27534 5.70019 5.85103C5.70019 6.62409 5.70019 7.4136 5.70019 8.18666C5.70019 9.10776 5.30123 9.6012 4.58643 9.61765C3.855 9.61765 3.45604 9.1242 3.45604 8.20311C3.45604 6.9695 3.45604 5.75234 3.45604 4.51873C3.45604 4.38714 3.50591 4.23911 3.37293 4.04173C3.19007 4.22266 3.04046 4.40359 2.87423 4.56807C2.39215 5.04507 1.76046 5.06152 1.31163 4.63386C0.862805 4.20621 0.846181 3.56474 1.31163 3.08774C2.12618 2.23244 2.95734 1.39358 3.78851 0.571179C4.23734 0.127079 4.95214 0.143528 5.38435 0.620524C6.14902 1.44293 6.98019 2.21599 7.76149 3.02195C8.27681 3.54829 8.31006 4.17332 7.86123 4.63386C7.39577 5.09441 6.74746 5.06151 6.21551 4.53517C6.08253 4.40359 5.96617 4.23911 5.83318 4.09108C5.78331 4.07463 5.75006 4.10752 5.70019 4.12397Z",
    fill: "white",
    stroke: "#67A6ED",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/uploadArrow.24021cab77a3ba20728bd0e5d8e734e1.svg";
export { ForwardRef as ReactComponent };